import { createWithEqualityFn as create } from 'zustand/traditional';
import type { UnsettledDigitalBillDto } from '../types/digitalBill';

interface DigitalBillActions {
  setActiveDigitalBill: (bill?: UnsettledDigitalBillDto) => void;
}

export interface DigitalBillState {
  activeDigitalBill?: UnsettledDigitalBillDto;
  actions: DigitalBillActions;
}

export const useDigitalBillStore = create<DigitalBillState>()((set, _get) => ({
  actions: {
    setActiveDigitalBill: (bill) => set({ activeDigitalBill: bill }),
  },

  activeDigitalBill: undefined,
}));

export const useActiveDigitalBill = () => useDigitalBillStore((state) => state.activeDigitalBill);
export const useDigitalBillActions = () => useDigitalBillStore((state) => state.actions);
